import type { FaireThemeEntity } from "../../entity_types/theme";

export const island_inspired_natural_soaps: FaireThemeEntity = {
  token: "island-inspired-natural-soaps",
  type: "theme",
  retailerToken: "r_bvuv8mj0x6",
  name: "Island-Inspired Natural Soaps",
  description: "Botanical soaps \u2014 a top gift pick",
  bgColor: "#D4EEF0",
  tileBgColor: "#9e2d39",
  productTokens: ["p_6oq110ae", "p_bwdss8q3", "p_2xa29d8h7t", "p_z34j5ckmg6"],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
